import useMediaQuery from 'pencil/useMediaQuery';
import useTheme from 'pencil/styles/useTheme';

export const useWidth = () => {
  const theme = useTheme();
  const width = [...theme.breakpoints.keys].reverse().reduce((output, key) => {
    const matches = useMediaQuery(theme.breakpoints.only(key));

    return !output && matches ? key : output;
  }, null) || 'xs';

  return width;
};
